import { render, staticRenderFns } from "./CertificatSpoticarPage.vue?vue&type=template&id=d87f7df4&"
import script from "./CertificatSpoticarPage.vue?vue&type=script&lang=js&"
export * from "./CertificatSpoticarPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports